import { useRef, useState } from 'react';
import ToolTip from './ToolTip';

interface TooltipForOnclickProps {
  text: string;
  children: React.ReactNode;
  minWidth?: string;
}

export const TooltipForCashback: React.FC<TooltipForOnclickProps> = ({
  text,
  children,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLLabelElement>(null);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setIsVisible(true);
    }
  };

  const handleKeyUp = (e: React.KeyboardEvent<HTMLSpanElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      setIsVisible(false);
    }
  };

  return (
    <div className="relative inline-block" ref={tooltipRef}>
      <span className="cursor-pointer">
        <label
          className="text-[#172B4D] text-base font-normal inline-flex items-center "
          ref={triggerRef}
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={() => setIsVisible(false)}
        >
          {children}{' '}
          {/* <span
            onMouseEnter={() => setIsVisible(true)}
            onMouseLeave={() => setIsVisible(false)}
            onKeyDown={handleKeyDown}
            onKeyUp={handleKeyUp}
            role="button"
            aria-label="Show tooltip"
            className="cursor-pointer ml-1"
            tabIndex={0}
          >
            ⓘ
          </span> */}
          <ToolTip text={text} position="top">
            <span className="cursor-pointer pl-1">ⓘ</span>
          </ToolTip>
        </label>
      </span>

      {/* {isVisible && (
        <div
          className="absolute z-10 bg-[#2F1869] text-white text-xs rounded-lg px-4 py-3 transform -translate-x-1/2 shadow-lg"
          style={{
            top: `-${(triggerRef.current?.offsetHeight || 24) + 106}px`,
            left: `${(triggerRef.current?.offsetHeight || 24) + 148}px`,
            minWidth: `${triggerRef.current?.offsetWidth || 100}px`,
            maxWidth: '280px',
          }}
          role="tooltip"
        >
          {text}
          <div className="w-0 h-0 border-l-[8px] border-r-[8px] border-t-[8px] border-l-transparent border-r-transparent border-t-[#2F1869] absolute left-1/2 bottom-[-8px] transform -translate-x-1/2" />
        </div>
      )} */}
    </div>
  );
};

export default TooltipForCashback;
